import { render, staticRenderFns } from "./silencedList.vue?vue&type=template&id=44666327&scoped=true"
import script from "./silencedList.vue?vue&type=script&lang=js"
export * from "./silencedList.vue?vue&type=script&lang=js"
import style0 from "./silencedList.vue?vue&type=style&index=0&id=44666327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44666327",
  null
  
)

export default component.exports